/** Locked application language until multi-language is re-enabled. */
export const APP_LANGUAGE = 'en';
